import type { Mission } from '../missions.ts'

export const epa: Mission = {
  id: "epa",
  name: "Environmental Protection Agency",
  short: "EPA",
  call: "Environment",
  kind: "independent",
  url: "https://www.epa.gov/",
  established: 1970,
  palette: {
    primary: "#0e6cb6",
    secondary: "#62c342",
    accent: "#41b6e6",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.epa.gov/aboutepa/using-epa-seal-and-logo",
  },
  motif: "flower",
  mission: {
    text: "The mission of EPA is to protect human health and the environment.",
    url: "https://www.epa.gov/aboutepa/our-mission-and-what-we-do",
  },
  fact: {
    text: "EPA marks its birthday on December 2, the date in 1970 when the Senate confirmed William Ruckelshaus as its first Administrator.",
    url: "https://www.epa.gov/history/origins-epa",
  },
  seal: {
    file: "public/seals/epa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Environmental_Protection_Agency.svg",
  },
  logo: {
    file: "public/logos/epa.svg",
    source: "https://commons.wikimedia.org/wiki/File:EPA_logo.svg",
  },
  identifier: {
    about: "https://www.epa.gov/aboutepa",
    accessibility: "https://www.epa.gov/accessibility/epa-accessibility-statement",
    foia: "https://www.epa.gov/foia",
    noFear: "https://www.epa.gov/ocr/no-fear-act-data",
    oig: "https://www.epa.gov/office-inspector-general",
    performance: "https://www.epa.gov/planandbudget",
    privacy: "https://www.epa.gov/privacy/privacy-and-security-notice",
  },
  media: {
    photos: [
      {
        file: "/media/epa-mono-lake.jpg",
        small: "/media/epa-mono-lake-sm.jpg",
        alt: "Tufa towers in silhouette frame Mono Lake glowing orange and pink at sunset.",
        title: "Sunset behind tufa towers, Mono Lake, California, April 1972 (DOCUMERICA)",
        creator: "Dick Rowan, for the Environmental Protection Agency DOCUMERICA project",
        source: "https://commons.wikimedia.org/wiki/File:SUNSET_BEHIND_TUFA_\"TOWERS\",_POROUS_ROCK_FORMATIONS_CREATED_BY_THE_HEAVY_SALINE_CONTENT_OF_MONO_LAKE_-_NARA_-_543140.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/epa-adirondack-lake.jpg",
        small: "/media/epa-adirondack-lake-sm.jpg",
        alt: "Tall pines in silhouette against a golden sunset sky reflected in the still water of Seventh Lake.",
        title: "Sunset over Seventh Lake, Adirondack Forest Preserve, New York, September 1973 (DOCUMERICA)",
        creator: "Anne LaBastille, for the Environmental Protection Agency DOCUMERICA project",
        source: "https://commons.wikimedia.org/wiki/File:SUNSET_OVER_SEVENTH_LAKE_IN_THE_ADIRONDACK_FOREST_PRESERVE_-_NARA_-_554760.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
